import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import routes from 'routes';
import Table from 'components/widgets/table';
import valuers from './valuersData';
import { ModalContext } from 'context/ModalContext';
import AddValuer from 'components/widgets/modals/AddValuer';
import { get_valuer_panel } from 'services/apiSrv';
import { useQuery } from 'react-query';

const StatsCard = ({ title, value, iconClass = 'fa-user', color = 'primary' }) => (
  <div className="col-md-4 mb-3">
    <div className={`card border-left-${color}`} style={{ borderLeftWidth: '4px' }}>
      <div className="card-body">
        <div className="row no-gutters align-items-center">
          <div className="col mr-2">
            <div className={`text-xs font-weight-bold text-${color} text-uppercase mb-1`}>
              {title}
            </div>
            <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">{value}</div>
          </div>
          <div className="col-auto">
            <i className={`fas ${iconClass} fa-2x text-gray-300`}></i>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default function ValuationPanel() {
  const history = useHistory();


  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
 const {
    data: valuers = [],
    isLoading: isValuers,
    error: subvaluerError,
  } = useQuery({
    queryKey: ['valuer_panel'],
    queryFn:get_valuer_panel,
  });
  const handleView = (id) => {
    // find the valuer object in current state so we can pass it to the view as navigation state
    const valuer = valuers?.data?.panel?.find((v) => v.valuerInternalRef === id) ;
    const path = routes.valuationView.replace(':id', id);
    if (valuer) {
      history.push(path, { valuer });
    } else {
      history.push(path);
    }
  };


 

// useEffect(()=>{
// console.log("===VALUERSPANEL", panel)
// },[panel])

console.log("===VALUERSPANEL", valuers?.data?.panel)



  const handleEdit = (id) => {
    alert(`Edit valuer ${id} (not implemented)`);
    console.log('Editing valuer', id);
  };

  // Open the Add Valuer modal
  const handleAdd = () => {
    setModalShow(true);
  };

  // Callback passed to the AddValuer modal form to insert the new valuer into the panel state
  const onAddValuer = (newValuer) => {
    // setData((prev) => [newValuer, ...prev]);
  };

  const tableFields = [
    { name: 'Image' },
    { name: 'Names' },
    { name: 'Contacts' },
    { name: 'Internal Ref' },
    { name: 'Created By' },
    { name: 'Actions' },
  ];

  const rowData = [
    { type: 'image', field: 'imagePath', domain: '' },
    { type: 'text', field: 'names' },
    { type: 'text', field: 'contacts' },
    { type: 'text', field: 'valuerInternalRef' },
    { type: 'text', field: 'createdBy' },
    {
      type: 'action',
      actions: [
        { method: handleView, field: 'valuerInternalRef', title: 'View' },
        { method: handleEdit, field: 'valuerInternalRef', title: 'Edit' },
      ],
    },
  ];

  return (
    <main style={{ padding: 24 }}>
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="text-center font-semibold">Valuers</h1>
      </div>

      <div className="row">
        <StatsCard title="Total Valuers" value={valuers?.data?.panel?.length} iconClass="fa-users" color="primary" />
      </div>

      <section style={{ marginTop: 24 }}>
        <div className="mb-3 d-flex justify-content-end">
          <button className="btn btn-primary" onClick={handleAdd}>
            <i className="fas fa-plus mr-2"></i> Add Valuer
          </button>
        </div>
        <Table title="Valuers" table_fields={tableFields} row_data={rowData} table_data={valuers?.data?.panel} pageSize={10} />
        <AddValuer show={modalShow} onHide={modalClose} onAdd={onAddValuer} />
      </section>
    </main>
  );
}
